import Vue from 'vue'

export default async (couponCode) => {
  let res = await Vue.axios.get(`/billing/coupons/check_code?code=${couponCode}&type=discount_invoice`)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/billing/checkCouponCode.js